import React from 'react'
import { Element } from 'react-bulma-components'

interface WorkPeriodEventIndicatesAbsenceDescriptionProps {
  textColor?: string
}

const WorkPeriodEventIndicatesAbsenceDescription: React.FC<
  WorkPeriodEventIndicatesAbsenceDescriptionProps
> = ({ textColor }) => {
  return (
    <Element textColor={textColor}>
      <Element renderAs="strong" textSize={7} textColor={textColor}>
        Indique absence
      </Element>{' '}
      : si coché, une journée avec cet évènement sera considérée comme une absence pour l'affichage
      des personnes présentes mais n'influe pas sur le calcul des heures de travail.
    </Element>
  )
}

export default WorkPeriodEventIndicatesAbsenceDescription
